import {
  IFieldServer,
  IFormServer,
  IFieldLevelRuleConditionClient,
  IFieldLevelRuleConditionMap,
  IFieldLevelRuleActionServer,
  IFieldLevelRuleClient,
  IPageLevelRuleConditionMap,
  IPageLevelRuleAction,
  IPageLevelRuleConditionClient,
  IFormLevelRuleClient,
  IFormLevelRuleConditionClient,
  IFormLevelRuleConditionMap,
  IFormLevelRuleConditionServer,
  IFormLevelRuleActionServer,
  ISetRuleValueActionFieldTypeServer,
  ISubmissionLevelRuleClient,
  ISubmissionLevelRuleConditionMap,
  ISubmissionLevelRuleActionServer,
  ISubmissionLevelRuleConditionClient,
  ISubmissionLevelRuleConditionServer,
} from "@common/redux/forms/interface";
import {
  IAdvancedRulesClient,
  IAdvancedRulesServer,
  IFieldLevelRuleServer,
  IFieldsMap,
  IForm,
  IFieldsToHIdeAndShow,
  IPageLevelRuleServer,
  IPageToHIdeAndShow,
  IFormLevelRuleServer,
  ISubmissionLevelRuleServer,
} from "@common/redux/formBuilder/interface";
import { transformCurrencyConfigServerToClient } from "@presentation/FormBuilder/components/FormCurrencyField/utils";
import { transformDropdownFieldConfigServerToClient } from "@presentation/FormBuilder/components/FormDropdownField/utils";
import {
  FieldProps,
  IFieldValuesConfiguration,
  FormFieldTypes,
} from "@presentation/FormBuilder/components/FormFieldSelector/interfaces";
import { transformFileUploadConfigServerToClient } from "@presentation/FormBuilder/components/FormFileUploadField/utils";
import { transformLinearScalingConfigServerToClient } from "@presentation/FormBuilder/components/FormLinearScaleField/utils";
import { transformMultiChoiceConfigServerToClient } from "@presentation/FormBuilder/components/FormMultipleChoicesField/utils";
import { transformTextAreatConfigServerToClient } from "@presentation/FormBuilder/components/FormTextAreaField/utils";
import { transformTextInputConfigServerToClient } from "@presentation/FormBuilder/components/FormTextInputField/utils";
import { transformFormLinkConfigServerToClient } from "@presentation/FormBuilder/components/FormLinkField/utils";
import { transformPaymentInputConfigServerToClient } from "@presentation/FormBuilder/components/FormPaymentInputField/utils/fieldUtils";
import { transformFormYearDropdownFieldConfigServerToClient } from "@presentation/FormBuilder/components/FormYearsDropdown/utils";
import {
  ConditionType,
  generateUniqueId,
  uniqueIdType,
} from "@presentation/FormBuilder/utils";
import {
  IFieldLevelRuleConditionServer,
  IPageLevelRuleClient,
  IPageLevelRuleConditionServer,
} from "@presentation/FormBuilder/components/ConfiguredRule/interface";
import { transformCalculativeInputConfigServerToClient } from "@presentation/FormBuilder/components/FormCalculativeInputField/utils";
import { transformSectionConfigServerToClient } from "@presentation/FormBuilder/components/FormSectionOverviewComponent/utils";
import { transformNumberInputConfigServerToClient } from "@presentation/FormBuilder/components/FormNumberInputField/utils";
import { transformLookUpConfigServerToClient } from "@presentation/FormBuilder/components/FormLookupField/utils";
import { transformGeolocationConfigServerToClient } from "@presentation/FormBuilder/components/FormGeolocationField/utils";
import { transformButtonConfigServerToClient } from "@presentation/FormBuilder/components/FormButtonField/utils";
import { transformTimeSlotFieldConfigServerToClient } from "@presentation/FormBuilder/components/FormTimeSlot/util";
import { transformSignatureFieldConfigServerToClient } from "@presentation/FormBuilder/components/FormSignatureComponent/utils";
import { transformDoublePanelFieldConfigServerToClient } from "@presentation/FormBuilder/components/FormDoublePanelField/utils";
import { transformLinkedDropdownConfigServerToClient } from "@presentation/FormBuilder/components/FormLinkedDropdownField/utils"
import {transformDescriptionFieldConfigServerToClient} from "@presentation/FormBuilder/components/DescriptionField/utils";
import sortObjectKeys from "hooks/sortObject";
import {
  IDatagridValue,
  IFieldSubmissionMap,
  IFormFieldSubmission,
} from "../formSubmission/interface";
import {
  extractDatagridFields,
  transformFieldSubmissionValueFromServerToClient,
  transformFieldSubmissionValuesClientToServer,
} from "../formSubmission/utils";
import { transformSequenceFieldConfigServerToClient } from "@presentation/FormBuilder/components/FormSequenceField/utils";
import { transformPincodeConfigServerToClient } from "@presentation/FormBuilder/components/FormPincodeField/utils";
import { IAttribute } from "../admin/interface";
import { convertEnglishToKannada } from "@utils/ConvertKannadaFunction"
import { monthDataFormat } from "@presentation/PricingPage/utils/dateFormatter";
import { transformCaptchaConfigServerToClient } from "@presentation/FormBuilder/components/FormCaptchaField/utils";
import { IOption } from "@erelego/design-system/components/atoms";
export const formInitialStateClient: IForm = {
  localId: "parentId",
  title: "Change Title",
  description: "",
  isMultipleForm: true,
  settings: {
    roles: [
      {
        title: "ADMIN",
        id: "parentId",
      },
    ],
    selectedRole: "parentId",
  },
  overviewForm: [],
  subForms: [],
  subFormsMap: {},
  isAnonymousSubAllowed: false,
  relatedFormIds: [],
  isOverviewAllowed: false,
  isReSubmissionAllowed: false,
  isDraftViewAllowed: false,
  isApprovalRequired: false,
  fieldsMap: {},
  themeId: "",
  activeSubformIndex: 0,
  name: "",
  isCompositeKeyEnabled: false,
  deleteActionRequired: false,
  compositeKeyFields: [],
  qrCodeRefPageIds: "",
  qrCodeRefField: "",
  isTemplate: false,
  fieldCount: 0,
  isValidationRequiredbeforeSubmission: false,
  isScriptOnFormSubmission: false,
  scriptOnSubmission:"",
  validationModal: false,
  otpModal: false,
  otpMethod: "",
  otpMethodValue : {
    content:"",
    value:""
  }
};
export const formInitialStateServer: IFormServer = {
  localId: "parentId",
  id: "",
  title: "Change Title",
  description: "",
  isMultipleForm: true,
  settings: {
    roles: [
      {
        title: "ADMIN",
        id: "parentId",
      },
    ],
    selectedRole: "parentId",
  },
  overviewForm: [],
  subForms: [],
  fields: [],
  themeId: "",
  isTemplate: false,
  fieldCount: 0
};

export const populateNewFieldAndTransformFromServerToClient = (
  fieldConfigData: IFieldServer,
  fieldId: string
) => {
  if (!fieldConfigData) return;
  const {
    fieldType,
    title,
    description,
    grid,
    isVisible,
    isDisabled,
    isRequired,
    fieldConfig,
    fields,
    rules,
    descriptionType,
    prefix,
    postfix,
    eyeIcon,
    completeEncrypt,
    sequenceType,
    hideFromVisiblity,
    generateSequenceByWorkflow,
    numericSequenceCount,
    defaultSequenceValue,
    dateRangeEnabled,
    isWeekendDisabled,
    specificDateSelectionEnabled,
    specificDateRangeEnabled,
    jsonApiEnabled,
    preDisableDateCount,
    postDisableDateCount,
    specificDates,
    specificDateRange,
    dateJsonApiUrl,
    slotDuration,
    slotSetting,
    dateReferralFieldId,
    isPartOfTimeSlot,
    isCurrentDateSelected,
    dateInitialValueType,
    isCurrentTimeSelected,
    timeInitialValueType,
    isCurrentDateTimeSelected,
    dateTimeInitialValueType,
    isPastDateDisabled,
    toFieldId,
    fromFieldId,
    fromTimeFieldId,
    toTimeFieldId,
    isRegularTimeFormat,
    isTimeOfDayRequired,
    timeOfDayFieldId,
    isMonthDisplayRequired,
    monthDisplayFieldId,
    timeOfDayConfig,
  } = fieldConfigData;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { isDuplicateAllowed, isPII } = fieldConfig;
  const settings = {
    visibility: {
      isVisible: isVisible,
      isDisabled: isDisabled,
    },
  };

  const fieldDataClient: FieldProps = {
    localId: fieldId,
    fieldType,
    isSection: fieldType == FormFieldTypes?.SECTION,
    title,
    description,
    isRequired,
    fields,
    rules,
    grid,
    settings,
    isDuplicateAllowed,
    descriptionType,
    isPII,
    prefix,
    postfix,
    eyeIcon,
    completeEncrypt,
    sequenceType,
    hideFromVisiblity,
    generateSequenceByWorkflow,
    numericSequenceCount,
    defaultSequenceValue,
    dateRangeEnabled,
    isWeekendDisabled,
    specificDateSelectionEnabled,
    specificDateRangeEnabled,
    jsonApiEnabled,
    preDisableDateCount,
    postDisableDateCount,
    specificDates,
    specificDateRange,
    dateJsonApiUrl,
    slotDuration,
    slotSetting,
    dateReferralFieldId,
    isPartOfTimeSlot,
    isCurrentDateSelected,
    dateInitialValueType,
    isCurrentTimeSelected,
    timeInitialValueType,
    isCurrentDateTimeSelected,
    dateTimeInitialValueType,
    isPastDateDisabled,
    fromFieldId,
    toFieldId,
    isRegularTimeFormat,
    fromTimeFieldId,
    toTimeFieldId,
    isTimeOfDayRequired,
    timeOfDayFieldId,
    isMonthDisplayRequired,
    monthDisplayFieldId,
    timeOfDayConfig,
  } as unknown as FieldProps;

  let fieldConfigClient: IFieldValuesConfiguration = {};

  if (fieldConfig) {
    switch (fieldType) {
      case FormFieldTypes.DROPDOWN:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformDropdownFieldConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.MULTIPLE_CHOICES:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformMultiChoiceConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.LINEAR_SCALING:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformLinearScalingConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.FILE_UPLOAD:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformFileUploadConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.CURRENCY:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformCurrencyConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.TEXT_INPUT:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformTextInputConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.FORM_LINK:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformFormLinkConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.YEAR_SELECTOR:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformFormYearDropdownFieldConfigServerToClient(fieldConfig);
        break
      case FormFieldTypes.LOOKUP:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformLookUpConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.TEXT_AREA:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformTextAreatConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.CALCULATIVE:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformCalculativeInputConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.NUMBER_INPUT:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformNumberInputConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.PIN_CODE:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformPincodeConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.PAYMENT:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformPaymentInputConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.GEOLOCATION:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformGeolocationConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.SEQUENCE:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformSequenceFieldConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.TIME_SLOT:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformTimeSlotFieldConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.BUTTON:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformButtonConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.SIGNATURE_BOX:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformSignatureFieldConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.DOUBLE_PANEL:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformDoublePanelFieldConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.CAPTCHA:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformCaptchaConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.DESCRIPTION:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformDescriptionFieldConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.BANNER:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformBannerConfigServerToClient(fieldConfig);
        break;
      case FormFieldTypes.LINKED_DROPDOWN:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fieldConfigClient = transformLinkedDropdownConfigServerToClient(fieldConfig);
        break;

      default:
        break;
    }
  }
  fieldDataClient.fieldValue = fieldConfigClient;
  return fieldDataClient;
};

export const populateNewSectionAndTransformToClient = (
  fieldConfigData: IFieldServer,
  fieldId: string
) => {
  const sectionfieldsMapClient: IFieldsMap = {};
  const formId = fieldId?.split("-")[0];
  if (!fieldConfigData) return;
  const {
    fieldType,
    title,
    description,
    isVisible,
    isDisabled,
    fields,
    isSection,
    name,
    element,
    type,
    grid,
    fieldConfig,
    prefix,
    postfix,
    eyeIcon,
    completeEncrypt,
    sequenceType,
    hideFromVisiblity,
    generateSequenceByWorkflow,
    numericSequenceCount,
    defaultSequenceValue,
    dateRangeEnabled,
    isWeekendDisabled,
    specificDateSelectionEnabled,
    specificDateRangeEnabled,
    jsonApiEnabled,
    preDisableDateCount,
    postDisableDateCount,
    specificDates,
    specificDateRange,
    dateJsonApiUrl,
    slotDuration,
    slotSetting,
    dateReferralFieldId,
    isPartOfTimeSlot,
    isCurrentDateSelected,
    dateInitialValueType,
    isCurrentTimeSelected,
    timeInitialValueType,
    isCurrentDateTimeSelected,
    dateTimeInitialValueType,
    isPastDateDisabled,
    fromFieldId,
    toFieldId,
    isRegularTimeFormat,
    fromTimeFieldId,
    toTimeFieldId,
    isTimeOfDayRequired,
    timeOfDayFieldId,
    isMonthDisplayRequired,
    monthDisplayFieldId,
    timeOfDayConfig,
  } = fieldConfigData;
  const fieldsClient = [];
  if (fieldConfigData?.fields?.length > 0) {
    fieldConfigData?.fields.forEach((fieldData: IFieldServer) => {
      const newFieldId = generateUniqueId(uniqueIdType.FIELD, formId);
      fieldsClient.push(newFieldId);
      sectionfieldsMapClient[newFieldId] =
        populateNewFieldAndTransformFromServerToClient(fieldData, newFieldId);
    });
  }
  const settings = {
    visibility: {
      isVisible: isVisible,
      isDisabled: isDisabled,
    },
  };

  const sectionDataClient: FieldProps = {
    localId: fieldId,
    isSection: isSection || fieldType == FormFieldTypes?.SECTION,
    fieldType,
    title,
    description,
    fields: fieldsClient,
    name,
    element,
    type,
    grid,
    prefix,
    postfix,
    eyeIcon,
    completeEncrypt,
    sequenceType,
    hideFromVisiblity,
    generateSequenceByWorkflow,
    numericSequenceCount,
    defaultSequenceValue,
    dateRangeEnabled,
    isWeekendDisabled,
    specificDateSelectionEnabled,
    specificDateRangeEnabled,
    jsonApiEnabled,
    preDisableDateCount,
    postDisableDateCount,
    specificDates,
    specificDateRange,
    dateJsonApiUrl,
    slotDuration,
    slotSetting,
    dateReferralFieldId,
    isPartOfTimeSlot,
    isCurrentDateSelected,
    dateInitialValueType,
    isCurrentTimeSelected,
    timeInitialValueType,
    isCurrentDateTimeSelected,
    dateTimeInitialValueType,
    isPastDateDisabled,
    fromFieldId,
    toFieldId,
    isRegularTimeFormat,
    fromTimeFieldId,
    toTimeFieldId,
    isTimeOfDayRequired,
    timeOfDayFieldId,
    isMonthDisplayRequired,
    monthDisplayFieldId,
    timeOfDayConfig,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    fieldValue: transformSectionConfigServerToClient(fieldConfig),
  } as unknown as FieldProps;
  sectionfieldsMapClient[fieldId] = sectionDataClient;
  return sectionfieldsMapClient;
};

export const changeFieldPosition = (
  activeFormData: IForm,
  draggedFieldPosition: number,
  dropFieldPosition: number,
  dropFormId: string,
  dragFormId: string
): IForm => {
  const newFieldDropPosition =
    dropFormId == dragFormId && draggedFieldPosition < dropFieldPosition
      ? dropFieldPosition - 1
      : dropFieldPosition;
  const { subFormsMap, fieldsMap } = activeFormData || {};
  let fieldId = "";
  let overviewForm: string[] = activeFormData?.overviewForm || [];

  // removing field from old position
  if (subFormsMap[dragFormId]) {
    //subform
    const existingFields = subFormsMap[dragFormId]?.fields || [];
    fieldId = existingFields?.splice(draggedFieldPosition, 1)[0];
    subFormsMap[dragFormId].fields = existingFields;
  }
  if (fieldsMap[dragFormId]) {
    //section
    const existingFields = fieldsMap[dragFormId]?.fields || [];
    fieldId = existingFields.splice(draggedFieldPosition, 1)[0];
    fieldsMap[dragFormId].fields = existingFields;
  }
  if (!dragFormId) {
    //overview form
    const existingFields = overviewForm || [];
    fieldId = existingFields.splice(draggedFieldPosition, 1)[0];
    overviewForm = existingFields;
  }

  // adding field to new position
  if (subFormsMap[dropFormId]) {
    //subform
    const existingFields = subFormsMap[dropFormId]?.fields || [];
    existingFields.splice(newFieldDropPosition, 0, fieldId);
    subFormsMap[dropFormId].fields = existingFields;
  }
  if (fieldsMap[dropFormId]) {
    //section
    const existingFields = fieldsMap[dropFormId]?.fields || [];
    existingFields.splice(newFieldDropPosition, 0, fieldId);
    fieldsMap[dropFormId].fields = existingFields;
  }
  if (!dropFormId) {
    //overview form
    const existingFields = overviewForm || [];
    existingFields.splice(newFieldDropPosition, 0, fieldId);
    overviewForm = existingFields;
  }

  const updatedActiveFormData: IForm = {
    ...activeFormData,
    overviewForm,
    subFormsMap,
    fieldsMap,
  };
  return updatedActiveFormData;
};

export const transformRuleDataServerToClient = (
  ruleDataServer: IAdvancedRulesServer
): IAdvancedRulesClient => {
  const formId = ruleDataServer?.formId;
  const fieldRules: IFieldLevelRuleServer[] =
    ruleDataServer?.fieldRules?.length > 0 ? ruleDataServer?.fieldRules : [];
  const pageRules: IPageLevelRuleServer[] =
    ruleDataServer?.pageRules?.length > 0 ? ruleDataServer?.pageRules : [];
  const formRules: IFormLevelRuleServer[] =
    ruleDataServer?.formRules?.length > 0 ? ruleDataServer?.formRules : [];
  const submissionRules: ISubmissionLevelRuleServer[] =
    ruleDataServer?.submissionRules?.length > 0
      ? ruleDataServer?.submissionRules
      : [];
  let fieldConditionMap = {};
  let pageConditionMap = {};
  let formConditionMap = {};
  let submissionConditionMap = {};
  let fieldsToIgnore = [];
  let formFieldsToIgnore = [];
  let subFormToIgnore = [];
  let activeFieldRuleCount = 0;
  let activePageRuleCount = 0;
  let activeFormRuleCount = 0;
  let activeSubmissionRuleCount = 0;

  const fieldRulesClient: IFieldLevelRuleClient[] = [];
  const pageRulesClient: IPageLevelRuleClient[] = [];
  const formRulesClient: IFormLevelRuleClient[] = [];
  const submissionRulesClient: ISubmissionLevelRuleClient[] = [];

  for (const index in pageRules) {
    const pageRuleServer: IPageLevelRuleServer = pageRules[index];
    const transformedPageRuleData: ITransformPageRuleDataServerToClient =
      transformPageRuleDataServerToClient(
        pageRuleServer,
        fieldsToIgnore,
        subFormToIgnore,
        activePageRuleCount,
        pageConditionMap
      );
    const {
      pageRuleClient,
      updateFieldsToIgnore,
      updateSubFormToIgnore,
      updatedActivePageRuleCount,
      updatedPageConditionMap,
    } = transformedPageRuleData;

    pageConditionMap = updatedPageConditionMap;
    fieldsToIgnore = updateFieldsToIgnore;
    subFormToIgnore = updateSubFormToIgnore;
    activePageRuleCount = updatedActivePageRuleCount;
    pageRulesClient.push(pageRuleClient);
  }

  for (const index in formRules) {
    const formRuleServer: IFormLevelRuleServer = formRules[index];
    const transformedFormRuleData: ITransformFormRuleDataServerToClient =
      transformFormRuleDataServerToClient(
        formRuleServer,
        formFieldsToIgnore,
        subFormToIgnore,
        activeFormRuleCount,
        formConditionMap
      );
    const {
      formRuleClient,
      updateFormFieldsToIgnore,
      updateSubFormToIgnore,
      updatedActiveFormRuleCount,
      updatedFormConditionMap,
    } = transformedFormRuleData;
    formConditionMap = updatedFormConditionMap;
    formFieldsToIgnore = updateFormFieldsToIgnore;
    subFormToIgnore = updateSubFormToIgnore;
    activeFormRuleCount = updatedActiveFormRuleCount;
    formRulesClient.push(formRuleClient);
  }

  for (const index in submissionRules) {
    const submissionRuleserver: ISubmissionLevelRuleServer =
      submissionRules[index];
    const transformedFormRuleData: ITransformSubmissionRuleDataServerToClient =
      transformSubmissionRuleDataServerToClient(
        submissionRuleserver,
        activeSubmissionRuleCount,
        submissionConditionMap
      );
    const {
      submissionRuleClient,
      updatedActiveSubmissionRuleCount,
      updatedSubmissionConditionMap,
    } = transformedFormRuleData;
    submissionConditionMap = updatedSubmissionConditionMap;
    activeSubmissionRuleCount = updatedActiveSubmissionRuleCount;
    submissionRulesClient.push(submissionRuleClient);
  }

  for (const index in fieldRules) {
    const fieldRuleServer: IFieldLevelRuleServer = fieldRules[index];
    const transformedFieldRuleData: ITransformFieldRuleDataServerToClient =
      transformFieldRuleDataServerToClient(
        fieldRuleServer,
        fieldsToIgnore,
        activeFieldRuleCount,
        fieldConditionMap
      );
    const {
      fieldRuleClient,
      updateFieldsToIgnore,
      updatedActiveFieldRuleCount,
      updatedFieldConditionMap,
    } = transformedFieldRuleData;

    fieldConditionMap = updatedFieldConditionMap;
    fieldsToIgnore = updateFieldsToIgnore;
    activeFieldRuleCount = updatedActiveFieldRuleCount;
    fieldRulesClient.push(fieldRuleClient);
  }
  const ruleDataClient: IAdvancedRulesClient = {
    formId,
    pageRules: pageRulesClient,
    formRules: formRulesClient,
    fieldRules: fieldRulesClient,
    submissionRules: submissionRulesClient,
    fieldConditionMap,
    pageConditionMap,
    formConditionMap,
    submissionConditionMap,
    fieldsToIgnore,
    subFormToIgnore,
    activeFieldRuleCount,
    activePageRuleCount,
    fieldsToHideAndShow: fieldsToHIdeAndShowInitialState,
    pageToHideAndShow: pageToHideAndShowInitialState,
  };
  return ruleDataClient;
};

export const fieldLevelRuleInitialValue: IFieldLevelRuleClient = {
  ruleName: "Untitled Field Rule",
  logicalOperator: "or",
  checkFieldRuleValidation: false,

  conditions: [
    {
      logicalOperator: "or",
      conditions: [
        {
          operator: "",
          value: "",
          fieldType: "",
          fieldLocalId: "",
        },
        // {
        //   operator: "",
        //   value: "",
        //   fieldType: "",
        //   fieldLocalId: "",
        // },
      ],
    },
    {
      // to remove later
      logicalOperator: "or",
      conditions: [
        {
          operator: "",
          value: "",
          fieldType: "",
          fieldLocalId: "",
        },
        // {
        //   operator: "",
        //   value: "",
        //   fieldType: "",
        //   fieldLocalId: "",
        // },
      ],
    },
  ],
  action: {
    show: [],
    hide: [],
  },
};
export const pageLevelRuleInitialValue: IPageLevelRuleClient = {
  ruleName: "Untitled Page Rule",
  logicalOperator: "or",
  checkPageRuleValidation: false,
  conditions: [
    {
      logicalOperator: "or",
      conditions: [
        {
          operator: "",
          value: "",
          fieldType: "",
          fieldLocalId: "",
        },
      ],
    },
  ],
  action: {
    skip: [],
    show: [],
    hide: [],
    elseSkip: [],
  },
};

export const formLevelRuleInitialValue: IFormLevelRuleClient = {
  ruleName: "Untitled Form Rule",
  logicalOperator: "or",
  checkFormRuleValidation: false,
  conditions: [
    {
      logicalOperator: "or",
      conditions: [
        {
          operator: "",
          value: "",
          fieldType: "",
          fieldLocalId: "",
        },
      ],
    },
  ],
  formAction: [
    {
      actionType: "REDIRECT",
      value: "",
    },
  ],
};

const fieldsToHIdeAndShowInitialState: IFieldsToHIdeAndShow = {
  hide: [],
  show: [],
};
const pageToHideAndShowInitialState: IPageToHIdeAndShow = {
  show: [],
  skip: [],
  hide: [],
  elseSkip: [],
};

export const ruleInitialStateClient: IAdvancedRulesClient = {
  formId: "",
  fieldRules: [],
  pageRules: [],
  formRules: [],
  fieldConditionMap: {},
  fieldsToIgnore: [],
  subFormToIgnore: [],
  activeFieldRuleCount: 2,
  activeFieldRuleIndex: 0,
  activePageRuleIndex: 0,
  fieldsToHideAndShow: fieldsToHIdeAndShowInitialState,
  pageToHideAndShow: pageToHideAndShowInitialState,
  submissionRules: [],
};

export const fieldLevelRuleInitialValueServerFormat: IFieldLevelRuleServer = {
  ruleName: "Untitled Field Rule",
  logicalOperator: "or",
  conditions: [
    {
      operator: "",
      value: "",
      fieldType: "",
      fieldLocalId: "",
    },
    // {
    //   operator: "",
    //   value: "",
    //   fieldType: "",
    //   fieldLocalId: "",
    // },
  ],
  action: {
    show: [],
    hide: [],
  },
};

export const pageLevelRuleInitialValueServerFormat: IPageLevelRuleServer = {
  ruleName: "Untitled Page Rule",
  logicalOperator: "or",
  conditions: [
    {
      operator: "",
      value: "",
      fieldType: "",
      fieldLocalId: "",
    },
  ],
  action: {
    skip: [],
    show: [],
    hide: [],
    elseSkip: [],
  },
};
export const formLevelRuleInitialValueServerFormat: IFormLevelRuleServer = {
  ruleName: "Untitled Form Rule",
  logicalOperator: "or",
  conditions: [
    {
      operator: "",
      value: "",
      fieldType: "",
      fieldLocalId: "",
    },
  ],
  formAction: [
    {
      actionType: "REDIRECT",
      value: "",
    },
  ],
};

export const submissionLevelRuleInitialValueServerFormat: ISubmissionLevelRuleServer =
{
  ruleName: "Untitled Form Rule",
  logicalOperator: "or",
  conditions: [
    {
      operator: "",
      value: "",
      fieldType: "",
      fieldLocalId: "",
      submissionConditionId: "",
    },
  ],
  submissionAction: {
    actionType: "POPUP",
    value: "",
  },
};

export const submissionLevelRuleInitialValue: ISubmissionLevelRuleClient = {
  ruleName: "Untitled Submission Rule",
  logicalOperator: "or",
  checkSubmissionRuleValidation: false,
  conditions: [
    {
      logicalOperator: "or",
      conditions: [
        {
          operator: "",
          value: "",
          fieldType: "",
          fieldLocalId: "",
        },
      ],
    },
  ],
  submissionAction: {
    actionType: "POPUP",
    value: "",
  },
};

export const ruleInitialValueServer: IAdvancedRulesServer = {
  formId: "",
  fieldRules: [fieldLevelRuleInitialValueServerFormat],
  pageRules: [pageLevelRuleInitialValueServerFormat],
  formRules: [formLevelRuleInitialValueServerFormat],
  submissionRules: [submissionLevelRuleInitialValueServerFormat],
};

export const subRuleInitialValueServer: IFieldLevelRuleConditionServer = {
  logicalOperator: "or",
  conditions: [
    {
      operator: "",
      value: "",
      fieldType: "",
      fieldLocalId: "",
    },
    // {
    //   operator: "",
    //   value: "",
    //   fieldType: "",
    //   fieldLocalId: "",
    // },
  ],
};

export const transformSubRuleDataServerToClient = (
  subRuleServer: IFieldLevelRuleConditionServer,
  existingFieldConditionMap: IFieldLevelRuleConditionMap,
  activeFieldRuleCount: number
): {
  fieldConditionMap: IFieldLevelRuleConditionMap;
  activeFieldRuleCount: number;
  subRuleId: string;
} => {
  const fieldConditionMap: IFieldLevelRuleConditionMap = {
    ...existingFieldConditionMap,
  };
  const { logicalOperator, conditions } = subRuleServer;
  const subRuleId: string = generateUniqueId(uniqueIdType.SUBRULE);
  const getFieldConditionIds = (
    fieldConditionServer: IFieldLevelRuleConditionServer
  ): string => {
    const {
      logicalOperator,
      operator,
      value,
      fieldType,
      fieldLocalId,
      subFormLocalId,
      conditions = [],
    } = fieldConditionServer;
    const fieldConditionIds: string[] = conditions.map(
      (fieldConditionsServer: IFieldLevelRuleConditionServer) =>
        getFieldConditionIds(fieldConditionsServer)
    );
    const fieldConditionId = generateUniqueId(uniqueIdType.CONDITION);

    let conditionName;
    if (!logicalOperator) {
      activeFieldRuleCount += 1;
      conditionName = `R${activeFieldRuleCount}`;
    }

    const fieldConditionClient: IFieldLevelRuleConditionClient = {
      fieldConditionId,
      logicalOperator,
      operator,
      value,
      fieldType,
      fieldLocalId,
      subFormLocalId,
      fieldConditionIds,
      conditionName,
    };
    fieldConditionMap[fieldConditionId] = fieldConditionClient;
    return fieldConditionId;
  };
  const fieldConditionIds: string[] = conditions.map(
    (fieldConditionsServer: IFieldLevelRuleConditionServer) =>
      getFieldConditionIds(fieldConditionsServer)
  );

  const updatedSubRuleData: IFieldLevelRuleConditionClient = {
    logicalOperator,
    fieldConditionIds,
    fieldConditionId: subRuleId,
  };
  fieldConditionMap[subRuleId] = updatedSubRuleData;

  return { fieldConditionMap, activeFieldRuleCount, subRuleId };
};
export interface ITransformFieldRuleDataServerToClient {
  fieldRuleClient: IFieldLevelRuleClient;
  updateFieldsToIgnore: string[];
  updatedActiveFieldRuleCount: number;
  updatedFieldConditionMap: IFieldLevelRuleConditionMap;
}

export const transformFieldRuleDataServerToClient = (
  fieldRuleServer: IFieldLevelRuleServer,
  fieldsToIgnore: string[],
  activeFieldRuleCount: number,
  fieldConditionMap: IFieldLevelRuleConditionMap
): ITransformFieldRuleDataServerToClient => {
  const updateFieldsToIgnore = [...(fieldsToIgnore ?? [])];
  const fieldsUsedInAction = [];
  let updatedActiveFieldRuleCount = activeFieldRuleCount;
  const updatedFieldConditionMap = { ...(fieldConditionMap ?? {}) };

  const ruleName = fieldRuleServer?.ruleName ?? "";
  const logicalOperator = fieldRuleServer?.logicalOperator ?? "";
  const conditions = fieldRuleServer?.conditions ?? [];
  const action: IFieldLevelRuleActionServer = fieldRuleServer?.action ?? {};
  const getFieldConditionIds = (
    fieldConditionServer: IFieldLevelRuleConditionServer
  ): string => {
    const {
      logicalOperator,
      operator,
      value,
      fieldType,
      fieldLocalId,
      subFormLocalId,
      conditions = [],
    } = fieldConditionServer;

    updateFieldsToIgnore.push(fieldLocalId);

    const fieldConditionIds: string[] = conditions.map(
      (fieldConditionsServer: IFieldLevelRuleConditionServer) =>
        getFieldConditionIds(fieldConditionsServer)
    );
    let conditionName;
    if (!logicalOperator) {
      updatedActiveFieldRuleCount += 1;
      conditionName = `R${updatedActiveFieldRuleCount}`;
    }

    const fieldConditionId = generateUniqueId(uniqueIdType.CONDITION);
    const fieldConditionClient: IFieldLevelRuleConditionClient = {
      fieldConditionId,
      logicalOperator,
      operator,
      value,
      fieldType,
      fieldLocalId,
      subFormLocalId,
      fieldConditionIds,
      conditionName,
    };
    // update fieldConditionMap
    updatedFieldConditionMap[fieldConditionId] = fieldConditionClient;
    return fieldConditionId;
  };

  for (const actionType in action) {
    for (const actionServer of action?.[actionType]) {
      const { fieldLocalId } = actionServer;

      updateFieldsToIgnore.push(fieldLocalId);
      fieldsUsedInAction.push(fieldLocalId);
    }
  }

  const fieldConditionIds: string[] = conditions.map(
    (fieldConditionsServer: IFieldLevelRuleConditionServer) =>
      getFieldConditionIds(fieldConditionsServer)
  );
  const fieldRuleClient: IFieldLevelRuleClient = {
    ruleName,
    ruleId: generateUniqueId(uniqueIdType.RULE),
    logicalOperator,
    action,
    checkFieldRuleValidation: false,
    fieldConditionIds,
    fieldsUsedInAction,
  };
  const updatedFieldRuleClientData: ITransformFieldRuleDataServerToClient = {
    fieldRuleClient,
    updateFieldsToIgnore,
    updatedActiveFieldRuleCount,
    updatedFieldConditionMap,
  };
  return updatedFieldRuleClientData;
};

export const transformPageRuleDataServerToClient = (
  pageRuleServer: IPageLevelRuleServer,
  fieldsToIgnore: string[],
  subFormToIgnore: string[],
  activePageRuleCount: number,
  pageConditionMap: IPageLevelRuleConditionMap
): ITransformPageRuleDataServerToClient => {
  const updateFieldsToIgnore = [...(fieldsToIgnore || [])];
  const updateSubFormToIgnore = [...(subFormToIgnore || [])];
  const fieldsUsedInAction = [];
  let updatedActivePageRuleCount = activePageRuleCount;
  const updatedPageConditionMap = { ...(pageConditionMap ?? {}) };
  const ruleName = pageRuleServer?.ruleName ?? "";
  const logicalOperator =
    pageRuleServer?.logicalOperator != null
      ? pageRuleServer?.logicalOperator
      : "";
  const conditions = pageRuleServer?.conditions ?? [];
  const action: IPageLevelRuleAction = pageRuleServer?.action ?? {};
  const getPageConditionIds = (
    pageConditionServer: IPageLevelRuleConditionServer
  ): string => {
    const {
      logicalOperator,
      operator,
      value,
      fieldType,
      fieldLocalId,
      subFormLocalId,
      conditions = [],
      action: conditionAction,
    } = pageConditionServer;

    updateFieldsToIgnore.push(fieldLocalId);
    updateSubFormToIgnore.push(subFormLocalId);

    const pageConditionIds: string[] = conditions.map(
      (pageConditionsServer: IPageLevelRuleConditionServer) =>
        getPageConditionIds(pageConditionsServer)
    );
    let conditionName;
    if (!logicalOperator) {
      updatedActivePageRuleCount += 1;
      conditionName = `R${updatedActivePageRuleCount}`;
    }

    const pageConditionId = generateUniqueId(uniqueIdType.CONDITION);
    const pageConditionClient: IPageLevelRuleConditionClient = {
      pageConditionId,
      logicalOperator,
      operator,
      value,
      fieldType,
      fieldLocalId,
      subFormLocalId,
      pageConditionIds,
      conditionName,
      action: conditionAction,
    };
    updatedPageConditionMap[pageConditionId] = pageConditionClient;
    return pageConditionId;
  };

  for (const actionType in action) {
    if (action?.[actionType] == null) continue;
    for (const actionServer of action?.[actionType]) {
      const { fieldLocalId, subFormLocalId } = actionServer;

      updateFieldsToIgnore.push(fieldLocalId);
      updateSubFormToIgnore.push(subFormLocalId);
      fieldsUsedInAction.push(fieldLocalId);
    }
  }

  const pageConditionIds: string[] = conditions.map(
    (pageConditionsServer: IPageLevelRuleConditionServer) =>
      getPageConditionIds(pageConditionsServer)
  );
  const pageRuleClient: IPageLevelRuleClient = {
    ruleName,
    ruleId: generateUniqueId(uniqueIdType.RULE),
    logicalOperator,
    action,
    checkPageRuleValidation: false,
    pageConditionIds,
    // fieldsUsedInAction,check and update
  };
  const updatedPageRuleClientData: ITransformPageRuleDataServerToClient = {
    pageRuleClient,
    updateFieldsToIgnore,
    updateSubFormToIgnore,
    updatedActivePageRuleCount,
    updatedPageConditionMap,
  };
  return updatedPageRuleClientData;
};

export const transformFormRuleDataServerToClient = (
  formRuleServer: IFormLevelRuleServer,
  fieldsToIgnore: string[],
  subFormToIgnore: string[],
  activeFormRuleCount: number,
  formConditionMap: IFormLevelRuleConditionMap
): ITransformFormRuleDataServerToClient => {
  const updateFormFieldsToIgnore = [...(fieldsToIgnore || [])];
  const updateSubFormToIgnore = [...(subFormToIgnore || [])];

  const fieldsUsedInAction = [];
  let updatedActiveFormRuleCount = activeFormRuleCount;
  const updatedFormConditionMap = { ...(formConditionMap ?? {}) };
  const ruleName = formRuleServer?.ruleName ?? "";
  const logicalOperator = formRuleServer?.logicalOperator ?? "";
  const conditions = formRuleServer?.conditions ?? [];
  const formAction: IFormLevelRuleActionServer[] =
    formRuleServer?.formAction ?? [];
  const getFormConditionIds = (
    formConditionServer: IFormLevelRuleConditionServer
  ): string => {
    const {
      logicalOperator,
      operator,
      value,
      fieldType,
      fieldLocalId,
      conditions = [],
      formAction,
    } = formConditionServer;

    updateFormFieldsToIgnore.push(fieldLocalId);

    const formConditionIds: string[] = conditions.map(
      (formConditionsServer: IFormLevelRuleConditionServer) =>
        getFormConditionIds(formConditionsServer)
    );
    let conditionName;
    if (!logicalOperator) {
      updatedActiveFormRuleCount += 1;
      conditionName = `R${updatedActiveFormRuleCount}`;
    }

    const formConditionId = generateUniqueId(uniqueIdType.CONDITION);
    const formConditionClient: IFormLevelRuleConditionClient = {
      formConditionId,
      logicalOperator,
      operator,
      value,
      fieldType,
      fieldLocalId,
      formConditionIds,
      conditionName,
      formAction,
    };
    updatedFormConditionMap[formConditionId] = formConditionClient;
    return formConditionId;
  };

  const formConditionIds: string[] = conditions.map(
    (formConditionsServer: IFormLevelRuleConditionServer) =>
      getFormConditionIds(formConditionsServer)
  );
  const formRuleClient: IFormLevelRuleClient = {
    ruleName,
    ruleId: generateUniqueId(uniqueIdType.RULE),
    logicalOperator,
    formAction,
    checkFormRuleValidation: false,
    formConditionIds,
    // fieldsUsedInAction,check and update
  };
  const updatedFormRuleClientData: ITransformFormRuleDataServerToClient = {
    formRuleClient,
    updateFormFieldsToIgnore,
    updateSubFormToIgnore,
    updatedActiveFormRuleCount,
    updatedFormConditionMap,
  };
  return updatedFormRuleClientData;
};

export const transformSubmissionRuleDataServerToClient = (
  submissionRuleServer: ISubmissionLevelRuleServer,
  activeSubmissionRuleCount: number,
  submissionConditionMap: ISubmissionLevelRuleConditionMap
): ITransformSubmissionRuleDataServerToClient => {
  let updatedActiveSubmissionRuleCount = activeSubmissionRuleCount;
  const updatedSubmissionConditionMap = { ...(submissionConditionMap ?? {}) };
  const ruleName = submissionRuleServer?.ruleName ?? "";
  const logicalOperator = submissionRuleServer?.logicalOperator ?? "";
  const conditions = submissionRuleServer?.conditions ?? [];
  const submissionAction: ISubmissionLevelRuleActionServer =
    submissionRuleServer?.submissionAction ?? {};
  const getSubmissionConditionIds = (
    submissionConditionServer: ISubmissionLevelRuleConditionServer
  ): string => {
    const {
      logicalOperator,
      operator,
      value,
      fieldType,
      fieldLocalId,
      conditions = [],
      submissionAction,
    } = submissionConditionServer;

    const submissionConditionIds: string[] = conditions.map(
      (submissionConditionsServer: ISubmissionLevelRuleConditionServer) =>
        getSubmissionConditionIds(submissionConditionsServer)
    );
    let conditionName;
    if (!logicalOperator) {
      updatedActiveSubmissionRuleCount += 1;
      conditionName = `R${updatedActiveSubmissionRuleCount}`;
    }

    const submissionConditionId = generateUniqueId(uniqueIdType.CONDITION);
    const submissionConditionClient: ISubmissionLevelRuleConditionClient = {
      submissionConditionId,
      logicalOperator,
      operator,
      value,
      fieldType,
      fieldLocalId,
      submissionConditionIds,
      conditionName,
      submissionAction,
    };
    updatedSubmissionConditionMap[submissionConditionId] =
      submissionConditionClient;
    return submissionConditionId;
  };

  const submissionConditionIds: string[] = conditions.map(
    (submissionConditionsServer: ISubmissionLevelRuleConditionServer) =>
      getSubmissionConditionIds(submissionConditionsServer)
  );
  const submissionRuleClient: ISubmissionLevelRuleClient = {
    ruleName,
    ruleId: generateUniqueId(uniqueIdType.RULE),
    logicalOperator,
    submissionAction,
    checkSubmissionRuleValidation: false,
    submissionConditionIds,
    // fieldsUsedInAction,check and update
  };
  const updatedSubmissionRuleClientData: ITransformSubmissionRuleDataServerToClient =
  {
    submissionRuleClient,
    updatedSubmissionConditionMap,
    updatedActiveSubmissionRuleCount,
  };
  return updatedSubmissionRuleClientData;
};
export interface ITransformSubmissionRuleDataServerToClient {
  submissionRuleClient: ISubmissionLevelRuleClient;
  updatedSubmissionConditionMap: ISubmissionLevelRuleConditionMap;
  updatedActiveSubmissionRuleCount: number;
}

export interface ITransformPageRuleDataServerToClient {
  pageRuleClient: IPageLevelRuleClient;
  updateFieldsToIgnore: string[];
  updateSubFormToIgnore: string[];
  updatedActivePageRuleCount: number;
  updatedPageConditionMap: IPageLevelRuleConditionMap;
}

export interface ITransformFormRuleDataServerToClient {
  formRuleClient: IFormLevelRuleClient;
  updateFormFieldsToIgnore: string[];
  updateSubFormToIgnore: string[];
  updatedActiveFormRuleCount: number;
  updatedFormConditionMap: IFormLevelRuleConditionMap;
}

export interface ITransformConditionDataServerToClient {
  fieldConditionId: string;
  updateFieldsToIgnore: string[];
  updatedActiveFieldRuleCount: number;
  updatedFieldConditionMap: IFieldLevelRuleConditionMap;
}

export const updateFieldsToIgnoreAndFieldsMapOnDeleteConditionOrSubRule = (
  fieldsToIgnore: string[],
  fieldConditionMap: IFieldLevelRuleConditionMap,
  fieldConditionId: string
): string[] => {
  let updatedFieldsToIgnore = fieldsToIgnore;

  const updateFieldsToIgnoreAndFieldsMap = (conditionIds: string[]) => {
    for (const index in conditionIds) {
      const conditionId = conditionIds[index];
      const fieldConditionData = { ...(fieldConditionMap[conditionId] ?? {}) };
      const { fieldConditionIds, fieldLocalId } = fieldConditionData;
      const filteredFieldsToIgnore = updatedFieldsToIgnore.filter((value) => {
        return value !== fieldLocalId;
      });
      delete fieldConditionMap[conditionId];
      updatedFieldsToIgnore = filteredFieldsToIgnore;
      if (fieldConditionIds && fieldConditionIds?.length > 0) {
        updateFieldsToIgnoreAndFieldsMap(fieldConditionIds);
      }
    }
  };

  updateFieldsToIgnoreAndFieldsMap([fieldConditionId]);
  return updatedFieldsToIgnore;
};

export const updatePagesToIgnoreAndPagesMapOnDeleteConditionOrSubRule = (
  pagesToIgnore: string[],
  pageConditionMap: IPageLevelRuleConditionMap,
  pageConditionId: string
): string[] => {
  let updatedPagesToIgnore = pagesToIgnore;
  const updatePagesToIgnoreAndPagesMap = (conditionIds: string[]) => {
    for (const index in conditionIds) {
      const conditionId = conditionIds[index];
      const pageConditionData = { ...(pageConditionMap[conditionId] ?? {}) };
      const { pageConditionIds, subFormLocalId } = pageConditionData;
      const filteredPagesToIgnore = updatedPagesToIgnore.filter((value) => {
        return value !== subFormLocalId;
      });
      delete pageConditionMap[conditionId];
      updatedPagesToIgnore = filteredPagesToIgnore;
      if (pageConditionIds && pageConditionIds?.length > 0) {
        updatePagesToIgnoreAndPagesMap(pageConditionIds);
      }
    }
  };
  updatePagesToIgnoreAndPagesMap([pageConditionId]);
  return updatedPagesToIgnore;
};

export const updateFormFieldsToIgnoreAndFormsMapOnDeleteConditionOrSubRule = (
  formFieldsToIgnore: string[],
  formConditionMap: IFormLevelRuleConditionMap,
  formConditionId: string
): string[] => {
  let updatedFormFieldsToIgnore = formFieldsToIgnore;
  const updateFormFieldsToIgnoreAndFormsMap = (conditionIds: string[]) => {
    for (const index in conditionIds) {
      const conditionId = conditionIds[index];
      const formConditionData = { ...(formConditionMap[conditionId] ?? {}) };
      const { formConditionIds, fieldLocalId } = formConditionData;
      const filteredFormFieldsToIgnore = updatedFormFieldsToIgnore.filter(
        (value) => {
          return value !== fieldLocalId;
        }
      );
      delete formConditionMap[conditionId];
      updatedFormFieldsToIgnore = filteredFormFieldsToIgnore;
      if (formConditionIds && formConditionIds?.length > 0) {
        updateFormFieldsToIgnoreAndFormsMap(formConditionIds);
      }
    }
  };
  updateFormFieldsToIgnoreAndFormsMap([formConditionId]);
  return updatedFormFieldsToIgnore;
};

export const getItemByIndex = (arr, n = 0) =>
  (n > 0 ? arr.slice(n, n + 1) : arr.slice(n))[0];
export const getFieldData = (fieldMap) => {
  let fieldDataObj = {};
  Object.keys(fieldMap).forEach((data) => {
    const fieldTypes = fieldMap[data].fieldType;
    if (fieldMap[data].fieldType in fieldDataObj) {
      fieldDataObj = {
        ...fieldDataObj,
        [fieldTypes]: fieldDataObj[fieldTypes] + 1,
      };
    } else {
      fieldDataObj = {
        ...fieldDataObj,
        [fieldTypes]: 0,
      };
    }
  });
  return fieldDataObj;
};

export const duplicateSection = (
  sectionData: FieldProps,
  fieldsMap: IFieldsMap,
  formId: string,
  newSectionId: string
): IFieldsMap => {
  if (!sectionData) return;
  const updatedFieldsMap = { ...fieldsMap };

  const getFieldData = (fieldId: string, parentFormId: string) => {
    if (!fieldId) return;
    const fieldDataClient: FieldProps = fieldsMap[fieldId];
    const { fields } = fieldDataClient;

    const newFieldId = generateUniqueId(uniqueIdType.FIELD, formId);
    const newFieldIds: string[] =
      fields?.length >= 0
        ? fields?.map((fieldId: string) => getFieldData(fieldId, newFieldId))
        : undefined;
    const duplicateFieldData = {
      ...fieldDataClient,
      localId: newFieldId,
      fields: newFieldIds,
      parentFormId: parentFormId,
    } as FieldProps;
    updatedFieldsMap[newFieldId] = duplicateFieldData;
    return newFieldId;
  };
  const newFieldIds: string[] =
    sectionData?.fields?.length >= 0
      ? sectionData?.fields?.map((fieldId: string) =>
        getFieldData(fieldId, newSectionId)
      )
      : undefined;

  const duplicateSectionData = {
    ...sectionData,
    localId: newSectionId,
    fields: newFieldIds,
    title: "Copy of " + (sectionData?.title || ""),
  } as FieldProps;
  updatedFieldsMap[newSectionId] = duplicateSectionData;

  return updatedFieldsMap;
};

export const isPaymentFieldExist = (fieldsMap: IFieldsMap): boolean => {
  for (const fieldId in fieldsMap) {
    const fieldData = fieldsMap[fieldId];
    if (fieldData.fieldType == FormFieldTypes.PAYMENT) {
      return true;
    }
  }
  return false;
};

export const isGeolocationFieldExist = (fieldsMap: IFieldsMap): boolean => {
  for (const fieldId in fieldsMap) {
    const fieldData = fieldsMap[fieldId];
    if (fieldData.fieldType == FormFieldTypes.GEOLOCATION) {
      return true;
    }
  }
  return false;
};

export const isPreviousData = <T>(oldData: T, newData: T) => {
  const sortedData = sortObjectKeys(oldData) as T;

  const newSortedData = sortObjectKeys(newData) as T;

  return JSON.stringify(sortedData) === JSON.stringify(newSortedData);
};

const optionsFieldType = ["LOOKUP", "DROPDOWN"];
export enum aggregateFuntionEnum {
  "AGE" = "age",
  "MONTHS" = "months",
  "DAYS" = "days",
  "CURRENT_MONTH" = "currentmonth",
  "PREVIOUS_MONTH" = "PREVIOUS_MONTH",
  "CURRENT_MONTH_KANNADA" = "currentmonthkannada",
  "PREVIOUS_MONTH_KANNADA" = "previousmonthkannada",
}
const updateDataGridValue = (
  data: any,
  fieldId: string,
  updatedValue: string,
  columnIdProp?: string,
) => {
  if (!data?.fieldSubmissionValue?.dataGridValue) return data;
  const updatedData = { ...data };
  const dataGridValue = updatedData?.fieldSubmissionValue?.dataGridValue;
  if (columnIdProp) {
    if (dataGridValue[columnIdProp]) {
      dataGridValue[columnIdProp] = {
        ...dataGridValue[columnIdProp],
        [fieldId]: {
          localId: fieldId,
          fieldSubmissionValue: {
            value: updatedValue,
          },
          isError: false,
          valueError: "",
          columnId: columnIdProp
        },
      };
    }
  } else {
    Object.keys(dataGridValue)?.forEach((columnId) => {
      dataGridValue[columnId] = {
        ...dataGridValue[columnId],
        [fieldId]: {
          localId: fieldId,
          fieldSubmissionValue: {
            value: updatedValue,
          },
          isError: false,
          valueError: "",
          columnId: columnId
        },
      };
    });
  }

  return updatedData;
};
function findDataGridContainingField(data: Record<string, any>, targetFieldId: string): string | null {
  for (const [key, field] of Object.entries(data)) {
    if (field && typeof field === "object" && "fieldType" in field && field?.fieldType === FormFieldTypes.DATA_GRID) {
      if (Array.isArray(field?.fields) && field?.fields?.includes(targetFieldId)) {
        return key;
      }
    }
  }
  return null;
}
const getGridId = (columnId: string) => {
  const gridId = columnId?.split("_column-id")?.[0];
  return gridId?.startsWith("_") ? gridId?.slice(1) : gridId;
}
function findParentId(data: Record<string, string[]>, targetId: string): string | null {
  for (const [parentId, childIds] of Object.entries(data)) {
    if (Array.isArray(childIds) && childIds.includes(targetId)) {
      return parentId;
    }
  }
  return null;
}
export const transformActionDataToSubmissionData = (
  valuesToUpdate: ISetRuleValueActionFieldTypeServer[],
  fieldSubmissionMap: IFieldSubmissionMap,
  profileMap?: any,
  attributes?: IAttribute,
  formId?: string,
  fieldsToHide?: string[],
  pageToHide?: string[],
  fieldsMap?: any
) => {
  const datagridFields: IDatagridValue = extractDatagridFields(fieldsMap);
  const datagridFieldIds: string[] = datagridFields?.datagridFields ?? [];
  const submissionData: IFormFieldSubmission[] = [];
  for (let i = 0; i < valuesToUpdate.length; i++) {
    let getActiveColumnId = "";
    const valueAction: ISetRuleValueActionFieldTypeServer = valuesToUpdate[i];
    const fieldId = valueAction?.fieldLocalId;
    if (datagridFieldIds.includes(fieldId)) {
      getActiveColumnId = fieldSubmissionMap[valueAction?.value]?.columnId;
      if (!getActiveColumnId && datagridFieldIds?.includes(valueAction?.value)) {
        for (const key in fieldSubmissionMap) {
          const field = fieldSubmissionMap[key];
          if (field?.fieldType === FormFieldTypes.DATA_GRID) {
            const dataGridValue = field?.fieldSubmissionValue?.dataGridValue;
            if (dataGridValue) {
              for (const dataKey in dataGridValue) {
                const dataRow = dataGridValue?.[dataKey];
                const nestedField = dataRow?.[valueAction?.value];
                if (nestedField) {
                  getActiveColumnId = nestedField?.columnId;
                  break;
                }
              }
            }
            if (getActiveColumnId) break;
          }
        }
      }
    }
    const existingSubmissionData = fieldSubmissionMap?.[fieldId];
    let fromFieldSubmissionData =
      fieldSubmissionMap?.[valueAction?.fromFieldId] ?? fieldSubmissionMap?.[valueAction?.value];
    if (!fromFieldSubmissionData) {
      for (const key in fieldSubmissionMap) {
        const field = fieldSubmissionMap[key];
        if (field?.fieldType === "DATA_GRID") {
          const dataGridValue = field?.fieldSubmissionValue?.dataGridValue;
          if (dataGridValue) {
            for (const dataKey in dataGridValue) {
              const dataRow = dataGridValue?.[dataKey];
              const nestedField = dataRow?.[valueAction?.value];
              if (nestedField) {
                fromFieldSubmissionData = nestedField;
                break;
              }
            }
          }
          if (fromFieldSubmissionData) break;
        }
      }
    }
    let updatedValue = valueAction?.value;
    if (updatedValue) {
      const fieldType =
        existingSubmissionData?.fieldType || valueAction?.fieldType || fieldsMap[valueAction?.value]?.fieldType ||fieldsMap[fieldId]?.fieldType || "";
      const aggragateFunction = valuesToUpdate?.[i]?.aggregateFunction;
      if (valueAction?.type == "INSERT_FIELD") {
        updatedValue = transformFieldSubmissionValuesClientToServer(
          fromFieldSubmissionData?.fieldType || "",
          fromFieldSubmissionData?.fieldSubmissionValue || ""
        );
        if (getActiveColumnId) {
          const datagridFieldId = getGridId(getActiveColumnId);
          let updatedValueData = fieldSubmissionMap[datagridFieldId]?.fieldSubmissionValue?.dataGridValue[getActiveColumnId]?.[valueAction?.value];

          updatedValue = transformFieldSubmissionValuesClientToServer(
            updatedValueData?.fieldType ?? fieldsMap[valueAction?.value]?.fieldType ?? "",
            updatedValueData?.fieldSubmissionValue || ""
          );
        }
        if (!optionsFieldType.includes(fieldType)) {
          updatedValue =
            updatedValue?.selectedOption ||
            updatedValue?.optionValue ||
            updatedValue;
        }
      } else if (valueAction?.type == "USER_FIELD") {
        const object = profileMap ? Object.keys(profileMap)?.[0] : "";
        if (updatedValue == "username") {
          updatedValue = profileMap?.[object]["name"];
        } else if (updatedValue == "phoneNumber") {
          updatedValue = profileMap?.[object]["mobile"];
        } else {
          updatedValue = profileMap?.[object][updatedValue];
        }
      } else if (valueAction?.type == "USER_FIELD") {
        const object = profileMap ? Object.keys(profileMap)?.[0] : "";
        if (updatedValue == "username") {
          updatedValue = profileMap?.[object]["name"];
        } else if (updatedValue == "phoneNumber") {
          updatedValue = profileMap?.[object]["mobile"];
        } else {
          updatedValue = profileMap?.[object][updatedValue];
        }
      } else if (valueAction?.type == "SYSTEM_FIELDS") {
        const todayDate = new Date();
        const formattedTodayDate = todayDate.toString();
        updatedValue = formattedTodayDate;
      }
      if (aggragateFunction) {
        if (getActiveColumnId) {
          const datagridId = findParentId(datagridFields?.datagridMapping, fieldId);
          let updatedValueData = fieldSubmissionMap[datagridId]?.fieldSubmissionValue?.dataGridValue[getActiveColumnId]?.[valueAction?.value];
          const submissionValue = updatedValueData.fieldSubmissionValue ?? "";
          let convertedValue = transformFieldSubmissionValuesClientToServer(
            updatedValueData?.fieldType ?? fieldsMap[updatedValueData?.localId]?.fieldType ?? "",
            submissionValue ?? ""
          );
          updatedValue = getUpdatedValueByAggreagate(aggragateFunction, convertedValue);
        } else {
          updatedValue = getUpdatedValueByAggreagate(aggragateFunction, fromFieldSubmissionData);
        }
      }

      const parentFormId = findDataGridContainingField(fieldsMap, fieldId);
      const parentFormIdFieldType = fieldsMap?.[parentFormId]?.fieldType;

      if (datagridFieldIds?.includes(fieldId)) {

        const datagridId = getGridId(getActiveColumnId);
        const existingGridSubmissionData = fieldSubmissionMap?.[parentFormId];

        if (getActiveColumnId) {
          const existingGridSubmissionData = fieldSubmissionMap?.[datagridId];
          const updatedData = updateDataGridValue(existingGridSubmissionData, fieldId, updatedValue, getActiveColumnId);

          submissionData.push(updatedData);
        } else if (aggragateFunction && !getActiveColumnId) {
          let columnId = "";
          datagridFieldIds.forEach(fieldId => {
            const fieldData = fieldsMap?.[fieldId] || {};
            if (fieldData?.fieldType == "CHECK_BOX") {
              columnId = fieldSubmissionMap?.[fieldId]?.columnId;
            }
          });
          const datagridId = findParentId(datagridFields?.datagridMapping, fieldId);

          const existingGridSubmissionData = fieldSubmissionMap?.[datagridId];
          if (columnId) {
            const updatedData = updateDataGridValue(existingGridSubmissionData, fieldId, updatedValue, columnId);
            submissionData.push(updatedData);
          }
        } else {
          const updatedData = updateDataGridValue(existingGridSubmissionData, fieldId, updatedValue);
          submissionData.push(updatedData);
        }

      } else {

        const submissionValue: any =
          transformFieldSubmissionValueFromServerToClient(
            fieldType,
            updatedValue,
            formId,
            fieldsToHide,
            pageToHide,
            fieldsMap
          );
        const updatedFieldSubmissionValue = submissionValue;
        const updatedSubmissionData: IFormFieldSubmission = {
          ...existingSubmissionData,
          localId: fieldId,
          fieldType: fieldType,
          fieldSubmissionValue: updatedFieldSubmissionValue,
        };
        submissionData.push(updatedSubmissionData);
      }
    }
  }

  return submissionData;
};
export const removeDuplicates = (strings) => {
  return strings.reduce((acc, cur) => {
    if (!acc.includes(cur)) {
      acc.push(cur);
    }
    return acc;
  }, []);
};

export const calculateAge = (birthDateInput: Date | string, returnType: 'age' | 'months' | 'days'): string => {
  // Convert string input to a Date object if necessary
  const birthDate = typeof birthDateInput === 'string' ? new Date(birthDateInput) : birthDateInput;
  const today = new Date();

  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();
  let days = today.getDate() - birthDate.getDate();

  // Adjust calculations if the current date is before the birth date in the month
  if (days < 0) {
    const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    days += lastMonth.getDate();
    months--;
  }

  if (months < 0) {
    months += 12;
    years--;
  }
  switch (returnType) {
    case 'age':
      return `${years}`;
    case 'months':
      return `${months}`;
    case 'days':
      return `${days}`;
    default:
      return '';
  }
};

export const getCurrentMonth = (dateInput: Date | string): string => {
  const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
  return date.toLocaleString("default", { month: "long" });
};

export const getPreviousMonth = (dateInput: Date | string): string => {
  const date = typeof dateInput === "string" ? new Date(dateInput) : new Date(dateInput);
  date.setDate(1);
  date.setMonth(date.getMonth() - 1);

  return date.toLocaleString("default", { month: "long" });
};
export const getUpdatedValueByAggreagate = (
  aggragateFunction: string,
  sourceFieldValue: any
) => {
  let updatedValue: string = "";
  let updatedSourcFieldValue = sourceFieldValue?.fieldSubmissionValue?.value ?? sourceFieldValue;
  if (!updatedSourcFieldValue) return "";
  switch (aggragateFunction) {
    case aggregateFuntionEnum.AGE:
      updatedValue = calculateAge(updatedSourcFieldValue as Date, aggregateFuntionEnum.AGE);
      break;
    case aggregateFuntionEnum.MONTHS:
      updatedValue = calculateAge(updatedSourcFieldValue as Date, aggregateFuntionEnum.MONTHS);
      break;
    case aggregateFuntionEnum.DAYS:
      updatedValue = calculateAge(updatedSourcFieldValue as Date, aggregateFuntionEnum.DAYS);
      break;
    case aggregateFuntionEnum.CURRENT_MONTH:
      updatedValue = getCurrentMonth(updatedSourcFieldValue as Date);
      break;
    case aggregateFuntionEnum.PREVIOUS_MONTH:
      updatedValue = getPreviousMonth(updatedSourcFieldValue as Date);
      break;
    case aggregateFuntionEnum.PREVIOUS_MONTH:
      updatedValue = getPreviousMonth(updatedSourcFieldValue as Date);
      break;
    case aggregateFuntionEnum.CURRENT_MONTH_KANNADA:
      const value = getPreviousMonth(updatedSourcFieldValue as Date);
      const upperCaseValueData = value.toUpperCase()
      updatedValue = monthDataFormat[upperCaseValueData]?.kn ?? "";
      break;
    case aggregateFuntionEnum.PREVIOUS_MONTH_KANNADA:
      const valueData = getPreviousMonth(updatedSourcFieldValue as Date);
      const upperCaseValue = valueData.toUpperCase()
      updatedValue = monthDataFormat[upperCaseValue]?.kn ?? "";
      break;
    case "to_kannada":
      updatedValue = convertEnglishToKannada(updatedSourcFieldValue as string);
      break;
  }
  return updatedValue;
};

